import { send } from 'server';
import { getDateForIms } from 'js/hooks/useFormatter/helpers';

export const changeDetails = ({ dataMap, addressDetails, contactAddress, customData, errorLevel = 1 }) => send({
    ID: 33045,
    description: 'Update player info',
    responses: [33006, 31008],
    changeTimestamp: getDateForIms(new Date()),
    dataMap,
    addressDetails,
    contactAddress,
    customData,
    errorLevel
});
